
import type { Information } from '@/types/constance';
export const useInformation = () => {
  return useState<Information>('information', () => ({
    job_description: "",
    position_name: "",
    company_name: "",
    resume_url: "",
    resume_name: "",
    code: "",
    order_id: "",
    thread_id: "",
    audio: false,
    video: false
  }))
}